import { Outlet, createFileRoute } from '@tanstack/react-router';

const OperatorsVerificationLayoutPage = () => {
  return <Outlet />;
};

export const Route = createFileRoute('/_protected/operators/verification')({
  component: OperatorsVerificationLayoutPage,
});
